export default "#### Get an instant finance quote\n\nGet your personalised online rate & repayment amount with ease.\n";